import { action, computed, makeObservable, observable } from 'mobx'

export class TimeWaiter {
  constructor(private readonly sunOfSec: number = 59) {
    makeObservable(this)
  }

  @observable private timeWait: number = 0
  private timerId: NodeJS.Timeout | null = null

  @computed
  get timeExpired() {
    const codeEta = `${this.timeWait / 1000}`
    return this.timeWait < 10000 ? `0${codeEta}` : codeEta
  }

  @computed
  get timeIsNotOver() {
    return this.timeWait > 0
  }

  startTimer = () => {
    this.setTimeWaitCodeSend(this.sunOfSec * 1000)
    this.timerId = setInterval(() => {
      this.setTimeWaitCodeSend(this.timeWait - 1000)
      if (this.timeWait <= 0) {
        this.clearTimer()
      }
    }, 1000)
  }

  clearTimer = () => {
    if (this.timerId) {
      clearInterval(this.timerId)
    }
  }

  @action
  private setTimeWaitCodeSend = (value: number) => {
    this.timeWait = value
  }
}
